export const Salutations = Object.freeze({
    Company: 1,
    Mrs: 2,
    Mr: 3
});